import { connect } from 'react-redux'
import { RouteComponentProps } from 'react-router'
import TeamMemberArchiveUserModal from '../../components/team-members/TeamMemberArchiveUserModal'
import { moveToArchive } from '../../state/actions/team_members/index'
import { IMemberSearchObject, IStoreState } from '../../types/index'

const mapStateToProps = (state: IStoreState, ownProps: RouteComponentProps<any>) => {
  return {
    teamMember: state.teamMember.items[ownProps.match.params.id],
    onClose: ownProps.history.goBack
  }
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    onArchiveClick: (teamMember: IMemberSearchObject) => {
      return dispatch(moveToArchive(teamMember))
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TeamMemberArchiveUserModal)



// WEBPACK FOOTER //
// ./src/containers/team-members/TeamMemberArchiveUserModal.ts